export default function Panel({ isConnect, panelShow, panelExit, panelData, cur }) {
  if (isConnect) return null;

  const handleClick = () => {
    if (!panelData?.url) return;
    const rawUrl = panelData.url.trim();
    const isSamePage =
      rawUrl === "/" ||
      rawUrl === "https://hogc.in/" ||
      rawUrl === window.location.origin + "/";

    if (isSamePage) {
      window.location.href = rawUrl;
    } else {
      const formattedUrl = /^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`;
      window.open(formattedUrl, "_blank");
    }
  };

  if (cur === 0) {
    return (
      <div id="hero-center" key={cur} className={`${panelShow ? "show" : ""} ${panelExit ? "hero-exit" : ""}`}>
        <div className="hero-content">
          <h2 className="hero-title">
            HOUSE OF GIOVANNI CORSI
          </h2>
          <div className="hero-sub1">A CURATED ECOSYSTEM OF VENTURES</div>
          <div className="hero-sub2">BUILT AS INDIVIDUAL WORLDS, CONNECTED AS ONE UNIVERSE.</div>
          <div className="hero-action">
            <span className="hero-action-text">ENTER THE WORLD</span>
            <div className="hero-up-arrow">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="var(--accent)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="panel" key={cur} className={`${panelShow ? "show" : ""} ${panelExit ? "panel-exit" : ""}`}>
      <div className="p-label">{panelData?.label}</div>
      <div className="p-name">{panelData?.name}</div>
      <div className="p-tag">{panelData?.tag}</div>
      {panelData?.url && (
        <button className="p-btn" onClick={handleClick}>Read More</button>
      )}
    </div>
  );
}
